import React from "react";
import {Box, Typography} from "@mui/material";
import {Message} from "./Models";

export const ChatBubble: React.FC<{ message: Message }> = React.memo(({message}) => {
    const isUser = message.role === 'user';

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: isUser ? 'flex-end' : 'flex-start',
            }}
        >
            <Box
                sx={(theme) => ({
                    width: '80%',
                    bgcolor: isUser ? theme.palette.primary.main : theme.palette.grey[100],
                    color: isUser ? theme.palette.primary.contrastText : theme.palette.text.primary,
                    px: 1.5,
                    py: 1,
                    borderRadius: 2,
                    borderTopRightRadius: isUser ? 0 : 16,
                    borderTopLeftRadius: isUser ? 16 : 0,
                    boxShadow: 1,
                    wordBreak: 'break-word',
                })}
            >
                <Typography variant="body1" dangerouslySetInnerHTML={{ __html: message.content }} />
                <Typography
                    variant="caption"
                    sx={{
                        display: 'block',
                        opacity: 0.7,
                        textAlign: isUser ? 'right' : 'left',
                        mt: 0.5,
                    }}
                >
                    { new Date(message.timeStamp).toLocaleTimeString() }
                    {/*{new Date(message.timestamp).toLocaleTimeString([], {*/}
                    {/*    hour: '2-digit',*/}
                    {/*    minute: '2-digit',*/}
                    {/*})}*/}
                </Typography>
            </Box>
        </Box>
    );
});